<template>
  <section class="info-cards">
    <article class="glass-card quote-card">
      <h2><AppIcon name="sparkle" />一句话</h2>
      <p class="quote-content">{{ quote.content }}</p>
      <p class="quote-source">— 「{{ quote.source }}」</p>
      <AppIcon class="card-moon" name="moon" />
    </article>

    <article class="glass-card weather-card">
      <h2><AppIcon name="sparkle" />天气预报</h2>
      <p class="weather-location" :class="`is-${weatherStatus}`">
        <span class="weather-status-dot"></span>{{ locationText }}
      </p>
      <div class="weather-body">
        <div>
          <p class="temperature">{{ weather.temperature }}<span>°C</span></p>
          <p>{{ weather.weatherText }}</p>
          <p>空气质量：{{ weather.airQuality }}</p>
          <p>{{ weather.tips }}</p>
          <a
            v-if="weatherStatus === 'live'"
            class="weather-source"
            href="https://open-meteo.com/"
            target="_blank"
            rel="noopener noreferrer"
          >数据：Open-Meteo / CAMS</a>
        </div>
        <div class="weather-cloud">
          <AppIcon name="cloud" />
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import AppIcon from './AppIcon.vue';

export default {
  name: 'InfoCards',
  components: { AppIcon },
  props: {
    quote: {
      type: Object,
      required: true
    },
    weather: {
      type: Object,
      required: true
    },
    weatherStatus: {
      type: String,
      default: 'configured'
    }
  },
  computed: {
    locationText() {
      if (this.weatherStatus === 'locating') {
        return '正在获取当前位置…';
      }
      if (this.weatherStatus === 'fallback') {
        return `默认地区：${this.weather.cityName || '未设置'}`;
      }
      if (this.weatherStatus === 'live') {
        return this.weather.cityName || '当前位置';
      }
      return this.weather.cityName || '天气配置';
    }
  }
};
</script>
